/*
 * @Author: qinmengyuan
 * @Date: 2024-03-28 14:10:17
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-05-15 13:51:18
 * @FilePath: \onetab\src\utils\index.ts
 */
declare const chrome: any;
/**
 * @name:
 * @description: 获取本地配置
 * @msg:
 * @param {*} name
 * @return {*}
 */
export const getLocalConfig = (name: string) => {
  return localStorage.getItem(name);
};
export const setLocalConfig = (name: string, param: any = {}) => {
  localStorage.setItem(name, param);
};
// 获取浏览器浏览记录列表
export const getHistoryUrls=() =>{
  const historyUrls = [];
  
  for (let i = 0; i < window.history.length; i++) {
    const state = window.history.state;
    const url = state ? state.url : window.location.href;
    historyUrls.push(url);
    
    window.history.go(-1); // 逐个获取历史记录条目的 URL
  }
  
  return historyUrls;
}
/**
 * 向Chrome发送消息
 * @param message 消息
 */
export const getData = (message) => {
  return new Promise((resolve) => {
    chrome.runtime.sendMessage(message, resolve);
  });
};
export const getParamsUrl=({url,data})=>{
  if(data){
    const paramsArray = [];  
    //拼接参数  
    Object.keys(data).forEach(key => paramsArray.push(key + '=' + data[key]))  
    if (url.search(/\?/) === -1) {  
        url += '?' + paramsArray.join('&')  
    } else {  
        url += '&' + paramsArray.join('&')  }
  }

  return url
}
export const throttle=(func, wait)=> {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        timer = null;
        func.apply(context, args);
      }, wait);
    }
  };
}

export const  debounce=(func, wait)=> {
  let timer;
  return function () {
      const context = this;
      const args = arguments;

      clearTimeout(timer)
      timer = setTimeout(function(){
          func.apply(context, args)
      }, wait);
  }
}

